import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import BismillahShareef from '../../assets/bismillah-shareef.png';
import LeftArrow from '../../assets/icons/arrow-left.svg';
import DownloadIcon from '../../assets/icons/download.svg';
import Logo from '../../assets/logo.png';
import { AuthenticatedGETRequest } from '../../utils';
import ScreenLoader from './ScreenLoader';
import ProgressModal from './modals/progress';

const ApplicantPDF = () => {
    const { search } = useLocation();
    const [userData, setUserData] = useState(null);
    let [URLparams, setURLParams] = useState(null);
    const [progress_model, setProgressModelOpening] = useState(false);

    useEffect(() => {
        const params = JSON.parse(
            '{"' +
                decodeURI(search)
                    .replace(/\?/g, '')
                    .replace(/"/g, '\\"')
                    .replace(/&/g, '","')
                    .replace(/=/g, '":"') +
                '"}',
        );
        setURLParams(params);
        const fetchData = async (endpoint) => {
            try {
                const { data } = await AuthenticatedGETRequest(endpoint);
                return data;
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        if (params && params.screen === 'applicants') {
            fetchData(`applicants/${params.id}`).then((data) => setUserData(data));
        } else if (params && params.screen === 'students') {
            fetchData(`students/${params.id}`).then((data) => setUserData(data));
        }
    }, [search]);

    return userData ? (
        <div className='flex column'>
            <ProgressModal open={progress_model} onClose={() => setProgressModelOpening(false)} />
            <div
                className='pdf_button back_button'
                id='back_button'
                onClick={() =>
                    window.location.replace(
                        `/dashboard/${URLparams.screen}/detail?id=${URLparams.id}`,
                    )
                }
            >
                <img src={LeftArrow} alt='back_icon' width={48} height={48} />
                <h4>واپس جائیں</h4>
            </div>
            <div
                className='pdf_button print_application_button'
                id='print_application_button'
                onClick={() => {
                    window.document.getElementById('back_button').style.display = 'none';
                    window.document.getElementById('print_application_button').style.display =
                        'none';
                    window.print();
                    window.document.getElementById('print_application_button').style.display =
                        'flex';
                    window.document.getElementById('back_button').style.display = 'flex';
                }}
            >
                <img src={DownloadIcon} alt='download_icon' width={48} height={48} />
                <h4>
                    {URLparams && URLparams.screen === 'applicants'
                        ? 'پرنٹ درخواست'
                        : 'پرنٹ ریکارڈ'}
                </h4>
            </div>

            <main className='A4_page' id='A4_page'>
                <div className='flex justifyCenter alignCenter'>
                    <img src={BismillahShareef} alt='BISMILLAH' style={{ width: '35%' }} />
                </div>
                <div className='flex justifyBetween alignStart' style={{ direction: 'ltr' }}>
                    <img
                        src={Logo}
                        alt='logo'
                        style={{ objectFit: 'contain' }}
                        height={120}
                        width={120}
                    />
                    <h4 className='form_heading'>درخواست داخلہ</h4>
                    <div className='flex column justifyStart' style={{ width: 200 }}>
                        <div className='flex justifyStart alignCenter reacord_values'>
                            <p className='record_label' style={{ textAlign: 'right' }}>
                                {URLparams && URLparams.screen === 'applicants'
                                    ? `: فارم نمبر `
                                    : `:
                                رجسڑیشن نمبر`}
                            </p>
                            <p className='record_value' style={{ fontSize: 16, marginRight: 8 }}>
                                {URLparams && URLparams.screen === 'applicants'
                                    ? userData.form_id || 0
                                    : userData.registration_id}
                            </p>
                        </div>

                        <div className='flex justifyStart alignCenter reacord_values'>
                            <p className='record_label' style={{ textAlign: 'right' }}>
                                : تاریخ داخلہ
                            </p>
                            <p className='record_value' style={{ fontSize: 16, marginRight: 8 }}>
                                {userData.date_of_admission}
                            </p>
                        </div>
                    </div>
                </div>

                <p className='flex justifyCenter alignCenter application_title'>
                    بخدمت جناب ناظم تعلیمات جامعہ نظامیہ رضویہ اندرون لوہاری دروازہ لاہور
                </p>

                <p className='flex justifyCenter alignCenter application_subtitle'>
                    السلام علیکم ورحمۃ اللہ وبرکاتہ
                </p>
                <p className='flex application_description'>
                    موٗدبانہ گزارش ہے کہ میں برائے تعلیم و تربیت جامعہ میں داخل ہونا چاہتا ہوں اور
                    میں نے جامعہ کی ہدایات و ضوابط کا مطالعہ کرلیا ہے۔ میں صدق دل سے عہدکرتا ہوں کہ
                    جملہ ہدایات و ضوابط کا حتی الامکان پابند رہوں گا، خلاف ورزی کی صورت میں ذمہ
                    دارانِ جامعہ میرے لیے جوبھی سزاتجویزکریں مجھے منظور ہے اور مجھے اس کے خلاف داخلی
                    و خارجی کسی قسم کی چارہ جوئی کا حق نہیں ہوگا، لہذا مجھے جامعہ میں داخل کرکے
                    ممنون فرمائیں۔
                </p>

                {/* Name + Father Name + DOB  */}
                <div className='flex justifyBetween w-100 mt_24'>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20' style={{ width: 130 }}>
                            نام امیدوار :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_field_fs_20'>{userData.name}</p>
                        </div>
                    </div>

                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 80 }}>
                            ولدیت :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_field_fs_20'>
                                {userData.father_name}
                            </p>
                        </div>
                    </div>

                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 150 }}>
                            تاریخ پیدائش :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_english_fields output_field_fs_20'>
                                {userData.date_of_birth}
                            </p>
                        </div>
                    </div>
                </div>

                {/* CNIC + Mobile + Alternative Number  */}
                <div className='flex justifyBetween w-100 mt_24'>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 150 }}>
                            شناختی کارڈ نمبر :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_english_fields output_field_fs_20'>
                                {userData.cnic}
                            </p>
                        </div>
                    </div>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20' style={{ width: 120 }}>
                            موبائل نمبر :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_english_fields output_field_fs_20'>
                                {userData.primary_phone_number}
                            </p>
                        </div>
                    </div>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 120 }}>
                            متبادل نمبر :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_english_fields output_field_fs_20'>
                                {userData.secondary_phone_number}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Permanent Address + District + Province */}
                <div className='flex justifyBetween w-100 mt_24'>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 80 }}>
                            مستقل پتا :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_field_fs_20'>
                                {userData.permanent_address}، {userData.permanent_city}،
                                {userData.permanent_state}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Present Address +  District + Province*/}
                <div className='flex justifyBetween w-100 mt_24'>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 80 }}>
                            موجودہ پتا :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_field_fs_20'>
                                {userData.current_address}، {userData.current_city}،
                                {userData.current_state}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Department + Section + Residency  */}
                <div className='flex justifyBetween w-100 mt_24'>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 120 }}>
                            شعبہ تعلیم :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_field_fs_20'>
                                {userData.department}
                            </p>
                        </div>
                    </div>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20' style={{ width: 60 }}>
                            درجہ :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_field_fs_20'>
                                {userData.class_room.name}
                            </p>
                        </div>
                    </div>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 160 }}>
                            داخلہ کی کیفیت :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_field_fs_20'>{userData.residency}</p>
                        </div>
                    </div>
                </div>

                {/* Current Islamic And Modern Education  */}
                <div className='flex justifyBetween w-100 mt_24'>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 250 }}>
                            تعلیمی قابلیت :<span style={{ margin: '0 8px' }}>(دینی)</span>
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_field_fs_20'>
                                {userData.current_religious_education}
                            </p>
                        </div>
                    </div>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20' style={{ width: 250 }}>
                            تعلیمی قابلیت(عصری) :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_english_fields output_field_fs_20'>
                                {userData.current_modern_education}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Former Religiou Institue and Leaving Reason */}
                <div className='flex justifyBetween w-100 mt_24'>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 200 }}>
                            سابقہ ادارے کا نام :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_field_fs_20'>
                                {userData.former_religious_education_institute}
                            </p>
                        </div>
                    </div>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20' style={{ width: 300 }}>
                            سابقہ ادارہ چھوڑنے کی وجہ :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_field_fs_20'>
                                {userData.reason_for_leaving_former_religious_institute}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Guardian Name and Father name */}
                <div className='flex justifyBetween w-100 mt_24'>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 280 }}>
                            سرپرست یا ضامن کا نام :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_field_fs_20'>
                                {userData.guardian_name}
                            </p>
                        </div>
                    </div>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20' style={{ width: 310 }}>
                            سرپرست یا ضامن کی ولدیت :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_field_fs_20'>
                                {userData.guardian_father_name}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Guardian Mobile number, Alternative number and CNIC  */}
                <div className='flex justifyBetween w-100 mt_24'>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 300 }}>
                            سرپرست کا شناختی کارڈ نمبر :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_english_fields output_field_fs_20'>
                                {userData.guardian_cnic}
                            </p>
                        </div>
                    </div>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20' style={{ width: 120 }}>
                            موبائل نمبر :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_english_fields output_field_fs_20'>
                                {userData.guardian_primary_phone_number}
                            </p>
                        </div>
                    </div>

                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 120 }}>
                            متبادل نمبر
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_english_fields output_field_fs_20'>
                                {userData.guardian_secondary_phone_number}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Guardian Present Address +  District + Province*/}
                <div className='flex justifyBetween w-100 mt_24'>
                    <div className='flex justifyStart w-100'>
                        <p className='output_field_fs_20 w-100' style={{ width: 250 }}>
                            سرپرست یا ضامن کا موجودہ پتا :
                        </p>
                        <div className='field_border w-100'>
                            <p className='output_fields output_field_fs_20'>
                                {userData.guardian_permanent_address}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Signatures +  Pictures */}
                <div className='flex justifyBetween w-100 mt_24'>
                    <div className='flex justifyStart w-100' style={{ maxWidth: 400 }}>
                        <img
                            src={userData.guardian_image_url}
                            style={{ borderRadius: '50%', border: '1px solid #000000' }}
                            height={130}
                            width={130}
                            alt='guardian_profile_picture'
                        />

                        <p
                            className='output_fields output_field_fs_20 w-100'
                            style={{
                                borderTop: '2px solid #000000',
                                paddingTop: 12,
                                maxWidth: 240,
                                margin: '120px 8px 0 0',
                            }}
                        >
                            {`دستخط سرپرست /ضامن`}
                        </p>
                    </div>

                    <div className='flex justifyStart w-100' style={{ maxWidth: 400 }}>
                        <img
                            src={userData.image_url}
                            style={{ borderRadius: '50%', border: '1px solid #000000' }}
                            height={130}
                            width={130}
                            alt='guardian_profile_picture'
                        />

                        <p
                            className='output_fields output_field_fs_20 w-100'
                            style={{
                                borderTop: '2px solid #000000',
                                paddingTop: 12,
                                maxWidth: 240,
                                margin: '120px 8px 0 0',
                            }}
                        >
                            {`دستخط درخواست دہندہ`}
                        </p>
                    </div>
                </div>

                <div className='flex justifyBetween alignEnd w-100 mt_24'>
                    <div className='flex column justifyStart w-100' style={{ maxWidth: 425 }}>
                        <p className='highlighter output_field_fs_20'> دفتری کاروائی کے لیے</p>
                        <p className='output_field_fs_20 w-100' style={{ margin: '12px 0 0' }}>
                            داخلہ منظور کیا جاتا ہے ،لہذا حسب گنجائش قیام و طعام کا انتظام کیا جائے
                        </p>
                    </div>

                    <div
                        className='flex justifyEnd w-100'
                        style={{ maxWidth: 400, margin: '12px 0 0 22px' }}
                    >
                        <div
                            className='flex column alignCenter w-100'
                            style={{ marginTop: 40, marginRight: 160 }}
                        >
                            <p
                                className='output_field_fs_20 w-100'
                                style={{
                                    borderTop: '2px solid #000000',
                                    paddingTop: 16,
                                    maxWidth: 240,
                                    textAlign: 'center',
                                }}
                            >
                                دستخط ناظم تعلیمات
                            </p>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    ) : (
        <ScreenLoader />
    );
};

export default ApplicantPDF;
